import { render, staticRenderFns } from "./superAceX.vue?vue&type=template&id=5dda4400&scoped=true"
import script from "./superAceX.vue?vue&type=script&lang=js"
export * from "./superAceX.vue?vue&type=script&lang=js"
import style0 from "./superAceX.vue?vue&type=style&index=0&id=5dda4400&prod&scoped=true&lang=css"
import style1 from "./superAceX.vue?vue&type=style&index=1&id=5dda4400&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dda4400",
  null
  
)

export default component.exports